import React from 'react'
import styled, { keyframes } from 'styled-components'
import success from '../images/loading-success@2x.png'

const popIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 96px;
    text-align: center;
    color: #081717;

    h3 {
        font-weight: 400;
        font-size: 16px;
        margin: 0 0 24px 0;
    }

    p {
        color: #7A8585;
        font-size: 14px;
        margin: 0;
        padding: 0 24px;
    }
`

const Icon = styled.img`
    width: 64px;
    height: 64px;
    margin-bottom: 24px;
    animation: ${popIn} 300ms forwards;
`

const ConnectionSuccess = ({ selectedBank, applicationName }) => (
    <Wrapper>
        <Icon src={success} />
        <h3>Link successful</h3>
        <p>Your {selectedBank} accounts are connected with {applicationName}.</p>
    </Wrapper>
)

export default ConnectionSuccess